var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'bg-white': _vm.isWhitePage},attrs:{"id":"content"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.currentContent,{tag:"component",on:{"scroll-to":_vm.scrollTo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }